import { Component, ElementRef, HostBinding, Input, OnInit, Renderer2 } from '@angular/core';
import { ButtonModule } from '@usitsdasdesign/dds-ng/button';
import { MediaService } from '../services/media.service';

@Component({
  selector: 'app-video',
  standalone: true,
  imports: [
    ButtonModule
  ],
  templateUrl: './video.component.html',
  styleUrl: './video.component.scss'
})
export class VideoComponent implements OnInit {
  @Input() poster: string;
  @Input() src: string;

  @HostBinding(`class.active`) isActive: boolean;
  observer: MutationObserver;
  observer2: MutationObserver;

  constructor(private mediaService: MediaService,
    private elRef: ElementRef,
    private renderer: Renderer2) {

  }
  ngOnInit(): void {
    this.observer = new MutationObserver(() => this.processPoster());
    this.observer2 = new MutationObserver(() => this.processVideo());
    this.observer.observe(this.elRef.nativeElement, { childList: true, subtree: true });
    this.observer2.observe(this.elRef.nativeElement, { childList: true, subtree: true });

    // Initial processing of images (if already rendered)
    this.processPoster();
    this.processVideo();
  }
  playVideo(video: HTMLVideoElement): void {
    this.isActive = true;

    video.controls = true;
    video.load();
    video.play();
  }

  closeVideo(video: HTMLVideoElement): void {
    this.isActive = false;

    video.controls = false;
    video.load();
  }
  processPoster(): void {
    const posterSrc = this.elRef.nativeElement.querySelectorAll('[poster-src]');
    Array.from(posterSrc).forEach((poster: any) => {
      if (!poster.getAttribute('data-processed')) {
        const posterSrc = poster.getAttribute('poster-src');
        if (posterSrc) {
          // Mark this image as processed to avoid duplicate handling
          poster.setAttribute('data-processed', 'true');
          // Call the API to fetch the image
          this.mediaService.getMedia(posterSrc).subscribe(
            (response) => {
              this.renderer.setAttribute(poster, 'poster', response.mediaPreSignedUrl);
            },
            (error) => {
              console.error(`Error fetching image for ${posterSrc}:`, error);
            }
          );
        }
      }
    });
  }

  processVideo(): void {
    const videoSrc = this.elRef.nativeElement.querySelectorAll('[video-src]');
    Array.from(videoSrc).forEach((video: any) => {
      if (!video.getAttribute('data-processed')) {
        const videoSrc = video.getAttribute('video-src');
        if (videoSrc) {
          // Mark this image as processed to avoid duplicate handling
          video.setAttribute('data-processed', 'true');
          // Call the API to fetch the image
          this.mediaService.getMedia(videoSrc).subscribe(
            (response) => {
              this.renderer.setAttribute(video, 'src', response.mediaPreSignedUrl);
            },
            (error) => {
              console.error(`Error fetching video for ${videoSrc}:`, error);
            }
          );
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
    if (this.observer2) {
      this.observer2.disconnect();
    }
  }

}
